
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getFileByService,
    getFileIconByExtension,
    getFileIndexByFormID,
    setFileIndexByFormID
} from "@/helpers/file-helper";
import {getBySelector} from "@/helpers/element-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import {showImageModal} from "@/components/layout/image-model-component.js";

export class LayerInfoInfoTypeFileComponent extends HTMLElement {
    constructor(){
        super();

        const mainTabIndex = this.getAttribute('data-main-tab-index')
        const key = this.getAttribute('data-key')
        const childKey = this.getAttribute('data-child-key')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const recordIndex = this.getAttribute('data-record-index')

        let attributeItem

        const featureInfo = window.attributeItems[featureKey][featureInfoKey]

        if(recordIndex === null) {
            attributeItem = featureInfo.attributeItems[key]
        } else {
            if(childKey) {

                attributeItem = featureInfo.records[recordIndex].attributeItems[key][childKey]
            } else {

                attributeItem = featureInfo.records[recordIndex].attributeItems[key]
            }
        }

        const mainTab = window.mainTabs[mainTabIndex]
        const bookmarkPresentationID = mainTab.BookmarkPresentationID
        const domainID = mainTab.DomainID

        let presentationID
        if(featureInfo.featureInfo.keyColumn || !bookmarkPresentationID) {
            presentationID = featureInfo.featureInfo.PresentationID
        }

        const fileName = attributeItem.Prefix + attributeItem.Value + attributeItem.Suffix

        const fileStreamed = attributeItem.FileStreamed
        const template = document.createElement('template');
        if(!fileName) {
            template.innerHTML = ``
        } else {

            let fileIconExtension
            const extension = fileName.split('.');
            if (extension !== undefined && extension !== null) {
                fileIconExtension = getFileIconByExtension(extension[extension.length - 1]);
            }

            setFileIndexByFormID(featureInfo.featureInfo.FormID, attributeItem.FormAttributeID)

            const fileIndex = getFileIndexByFormID(featureInfo.featureInfo.FormID, attributeItem.FormAttributeID)

            let fileSource
            if(fileStreamed) {
                if (domainID && presentationID) {
                    fileSource = window.kaartViewerUrl + `/admin/v2/kaartviewerapi/bookmark/` + window.websiteID + `/domain/` + domainID + `/presentation/` + presentationID + `/formattribute/` + attributeItem.FormAttributeID + `/item/${fileIndex}/filename/` + fileName + `?time=` + new Date().getTime()
                } else {
                    fileSource = window.kaartViewerUrl + `/admin/v2/kaartviewerapi/bookmark/` + window.websiteID + `/bookmarkpresentation/` + bookmarkPresentationID + `/formattribute/` + attributeItem.FormAttributeID + `/item/${fileIndex}/filename/` + fileName + `?time=` + new Date().getTime()
                }
            } else {
                fileSource = fileName
            }

            // window.fileIndex++

            if(fileIconExtension.isImage) {
                if(fileStreamed) {
                    getFileByService(fileSource).then(blob => {

                        console.log('blob')

                        template.innerHTML = `<img class="cursor-pointer" style="max-width: 100%;" src="${URL.createObjectURL(blob)}"/>`;

                        initWebComponent(this, template)
                    })
                } else {
                    template.innerHTML = `<img class="cursor-pointer" style="max-width: 100%;" src="${fileSource}"/>`;

                    initWebComponent(this, template)
                }

                this.addEventListener('click', (e) => {
                    showImageModal(e.target.src)
                })

            } else if(fileIconExtension.isVideo) {
                template.innerHTML = `
                <video width="100%" height="100%" controls loop autoplay muted>
                  <source src="${fileSource}" type="video/mp4">
                  Your browser does not support the video tag.
                </video>`;

                initWebComponent(this, template)
            } else {
                template.innerHTML = `<a title="${fileName}" class="text-secondary" href="${fileSource}" target="_blank"><span class="${fileIconExtension.icon}"></span> ${fileName}</a>`

                initWebComponent(this, template)

                this.addEventListener('click', (e) => {
                    if(getToken()) {
                        e.preventDefault()
                        getFileByService(fileSource).then((response) => {
                            const fileLink = document.createElement('a');
                            fileLink.href = URL.createObjectURL(response);
                            fileLink.download = fileName;
                            fileLink.click();
                        })
                    }
                })
            }
        }
    }
}

